import { timeFormat } from '@visx/vendor/d3-time-format';

export const formatShortDate = timeFormat('%m%/%d');
export const formatLongDate = timeFormat('%B %e, %Y');

export const formatDate = (date: number | string) => formatShortDate(new Date(date));

export const formatUsd = (number: number | string) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumSignificantDigits: 3,
        maximumFractionDigits: 2,
        notation: 'compact',
    }).format(Number(number));
};

export const formatUsdLong = (number: number | string) => {
    const num = Number(number);
    const decimals = num.toString().split('.')[1] ?? '';
    const firstNonZeroIndex = decimals.split('').findIndex(decimal => decimal !== '0');
    const precision = firstNonZeroIndex > 2 ? firstNonZeroIndex + 2 : 2;

    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: precision,
    }).format(num);
};

const CURRENCY_SYMBOLS = {
    BTC: '₿',
} as const;

export const formatBtc = (value: number | string) => {
    const num = +value;
    const parts = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 8,
        minimumFractionDigits: 8,
    }).formatToParts(num);

    return parts.reduce((acc, part) => {
        if (part.type === 'currency') {
            return acc + CURRENCY_SYMBOLS.BTC;
        }
        return acc + part.value;
    }, '');
};

export const formatNumberCompact = (number: number | string) => {
    return Number(Number(number)).toLocaleString(undefined, {
        notation: 'compact',
        maximumFractionDigits: 2,
    });
};

export const formatPercent = (number: number | string) => {
    return Number(Number(number) / 100).toLocaleString(undefined, {
        style: 'percent',
        minimumFractionDigits: 2,
    });
};

export const startCase = (value: string) => {
    return String(value)
        .split(/_|-|\s/)
        .map(part => part.charAt(0).toUpperCase() + part.slice(1, part?.length))
        .join(' ');
};
